<div class="card">
  <div class="card-body">
    @if (isForSystemTest) {
      <div style="color: red; font-weight: bold; font-size: 16px; margin-bottom: 10px;">
        <a><b>Dieser Mandant ist für Systemtests angelegt!</b></a>
        <br><br>
      </div>
    }
    <form [formGroup]="editTenantForm" novalidate>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field style="width: 0; height: 0;">
            <input matInput hidden  formControlName="id">
          </mat-form-field>
        </div>
      </div>
      <!-- <div class="row">
      <div class="col-md-12">
        <mat-form-field class="example-full-width">
          <input matInput placeholder="{{this.translate.data['INPUTTENANTNAME'] | translate}}" formControlName="name" readonly>
        </mat-form-field>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="example-full-width">
          <mat-label>Scope</mat-label>
          <input matInput formControlName="scopeName" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="example-full-width">
          <mat-label>Frontend URL</mat-label>
          <input matInput formControlName="frontendUrl" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <mat-form-field class="example-full-width">
          <mat-label>System Typ</mat-label>
          <input matInput formControlName="systemType" readonly>
        </mat-form-field>
      </div>
    </div>
    @if (systemType === 'WINPLAN') {
      <div class="row">
        <div class="col-md-12">
          <mat-form-field class="example-full-width">
            <mat-label>Winplan Mandant</mat-label>
            <input matInput formControlName="wpTenant" readonly>
          </mat-form-field>
        </div>
      </div>
    }
    @if (systemType === 'WINPLAN') {
      <div class="row">
        <div class="col-md-12">
          <mat-form-field class="example-full-width">
            <mat-label>Winplan Api Key Inbound</mat-label>
            <input matInput formControlName="wpApiKeyInbound" readonly>
          </mat-form-field>
        </div>
      </div>
    }
    @if (systemType === 'WINPLAN') {
      <div class="row">
        <div class="col-md-12">
          <mat-form-field class="example-full-width">
            <mat-label>Winplan Api User</mat-label>
            <input matInput formControlName="wpApiUser" readonly>
          </mat-form-field>
        </div>
      </div>
    }
    @if (systemType === 'WINPLAN') {
      <div class="row">
        <div class="col-md-12">
          <mat-form-field class="example-full-width">
            <mat-label>Winplan Api Key</mat-label>
            <input matInput formControlName="wpApiKey" readonly>
          </mat-form-field>
        </div>
      </div>
    }
    <!-- <div class="row">
    <div class="col-md-12">
      <mat-form-field class="example-full-width">
        <input matInput placeholder="Max. Anzahl Mitglieder" formControlName="maxUserCount">
      </mat-form-field>
    </div>
  </div> -->

  <div class="row">
    @if (preview) {
      <div>
        <!-- <h4>Vorschau:</h4> -->
        <img [src]="preview" alt="Preview" style="margin-left: 16px; margin-top: 8px; max-width: 100px; border:1px solid #ccc;">
      </div>
    }
    <button mat-raised-button class="btn btn-squirrel" style="max-height: 41.15px; margin-top: 6px;margin-left: 16px" (click)="fileInput.click()">Bild hochladen</button>
    <input
      #fileInput
      type="file"
      accept="image/*"
      (change)="onFileSelected($event)"
      style="display:none"
      />
      <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="Bild in der Ansicht entfernen"
      (click)="removeImage()" >Bild entfernen</button>
    </div>

    <br><br>
    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
    (click)="cancel()" >Abbruch</button>
    <!-- <span style="flex: 1 1 auto"></span> -->
    <button mat-raised-button type="submit" class="btn btn-squirrel pull-right"
    (click)="editTenant()">{{this.translate.data['MODIFY'] | translate}}</button>
    <div class="clearfix"></div>
  </form>
</div>
</div>